<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>

    <b-card class="bCardConfiguracion">
      <b-container fluid="">
        <b-row class="divSubtitulo m-1 mb-3">
          <b-col cols="6" md="8">
            <div>
              <p class="textoSubtitulo">CONFIGURACIÓN HERRAMIENTAS ECE</p>
            </div>
          </b-col>
          <b-col cols="6" md="4">
            <div>
              <p style="text-align:right" class="textoSubtitulo">CÓDIGO: Conf_Hdx_ECE</p>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <loading
          :active.sync="loader"
          :can-cancel="false"
          :is-full-page="true"
      ></loading>
        <b-row class="text-center">
          <b-col cols="1" md="3"></b-col>

          <b-col cols="9" md="6">
            <div>
            <b-row class="contenedorTablaSinColor" style="background:white">
              <b-col cols="10" lg="11" class="pr-0">
                <b-input-group class="pl-3">
                  <b-form-input
                      class="input-filter"
                      maxLength="15"
                      v-model="filtro.palabraClave"
                      type="search"
                      id="nombreBusq"
                      name="nombre"
                      responsive
                      placeholder="Búsqueda de herramienta"
                      @keydown.enter.native="obtenerConfigHerramientasECE">
                  </b-form-input>
                </b-input-group>
              </b-col>
              <b-col cols="2" lg="1" class="pl-0">
                <b-button
                    class="mt-1"
                    size="sm"
                    variant="info"
                    :disabled="loader"
                    responsive
                    @click="obtenerConfigHerramientasECE"
                >
                <span v-if="!loader"
                >
                  <em class="buscar_svg primary sm"></em>
                </span>
                  <span v-else><b-spinner small></b-spinner></span>
                </b-button>
              </b-col>
            </b-row>
            </div>
          </b-col>

          <b-col cols="1" class="text-left">
            <b-button
                v-if="$localStorageService.can('ECE_01_conf_Hdx_crear')"
                variant="primary"
                v-b-tooltip.hover
                title="Crear herramienta"
                class="paddingbotones botonesAzulFuerte"
                @click="agregar()"
                responsive
            ><em class="herramienta_svg icon-boton"></em>
            </b-button>
          </b-col>

          <div class="col-12" >
            <br>
            <b-row >
              <b-col sm="12" md="12" lg="12">
                <b-table class="contenedorTablaSinColor"
                    id="Pendientes"
                    thead-tr-class="columnasTablaSinColor"
                    :items="datosTabla"
                    :fields="fields"
                    :per-page="registrosPorPagina"
                    :current-page="paginaActual"
                    responsive="true"
                    fixed
                >
                  <template v-slot:cell(flujo)="row">
                    <span>{{row.item.flujo.flujoExpedienteDigial}}</span>
                  </template>

                  <template v-slot:cell(Acciones)="row" style="width: 200px">
                    <b-button-group>
                      <b-button size="sm" variant="warning" class=" mr-1 marginbotones "
                                style="border-radius:15px"
                                v-if="$localStorageService.can('ECE_01_conf_Hdx_edit')"
                                v-b-tooltip.hover
                                title="Modificar herramienta"
                                @click="modificar(row.item)"
                      >
                        <em class="editar_svg sm"></em>
                      </b-button>
                      <b-button size="sm" variant="secondary" class=" mr-1 marginbotones "
                                style="border-radius:15px"
                                v-if="!row.item.registroActivo && $localStorageService.can('ECE_01_conf_Hdx_act')"
                                v-b-tooltip.hover
                                title="Activar herramienta"
                                @click="activarDesactivarConfiguracion(row.item)">
                        <em v-if="!row.item.loader" class="fa fa-undo"></em>
                        <b-spinner v-else small></b-spinner>
                      </b-button>

                      <b-button size="sm" variant="danger" class=" mr-1 marginbotones "
                                style="border-radius:15px"
                                v-else-if="$localStorageService.can('ECE_01_conf_Hdx_act')"
                                v-b-tooltip.hover
                                title="Desactivar herramienta"
                                @click="activarDesactivarConfiguracion(row.item)"
                      >
                        <em v-if="!row.item.loader" class="equis_svg icon-boton sm"></em>
                        <b-spinner v-else small></b-spinner>
                      </b-button>
                    </b-button-group>
                  </template>
                </b-table>


                <b-col v-if="!loader">
                  <b-alert v-if="datosTabla.length === 0" variant="warning" show>No hay datos</b-alert>
                </b-col>
                <b-col v-if="!loader">
                  <b-pagination
                      v-if="datosTabla !== undefined && datosTabla.length > 10"
                      align="center"
                      v-model="paginaActual"
                      :total-rows="datosTabla.length"
                      :per-page="registrosPorPagina"
                  ></b-pagination>
                </b-col>
              </b-col>
            </b-row>
          </div>

        </b-row>

        <b-modal
            v-model="show"
            size="xl"
            class="redondeo"
            centered
            :no-close-on-backdrop="true">

          <template #modal-header="{ ok, close }">
            <div class="seccionTitle mLeft h5">
              <em class="icono cita_svg" style="filter: invert(18%) sepia(86%) saturate(1218%) hue-rotate(179deg) brightness(93%) contrast(90%); height: 30px"></em>
              <div class="headerTxt mLeft">{{tituloModal}}</div>
            </div>
          </template>


            <b-row cols="1" cols-md="2" class="mr-3">
              <b-col>
                <loading :active.sync="loader" :can-cancel="false" :is-full-page="true"></loading>
                <b-form @submit.stop.prevent="guardar">
                    <b-row cols="1" cols-md="2" class="mr-3">

                    <b-col>
                      <b-form-group align="left">
                        <label for="herramientas">Nombre de Herramienta
                        </label>
                        <validacion/>
                        <b-input-group size="sm" class="mb-2">
                          <b-form-input
                              class="redondeo"
                              id="herramientas"
                              name="herramientas"
                              placeholder="Nombre de la herramienta"
                              v-model="$v.configuracion.nombreHerramienta.$model"
                              :state="validateState('nombreHerramienta')"
                          ></b-form-input>
                        </b-input-group>
                      </b-form-group>
                    </b-col>

                    <b-col>
                      <b-form-group align="left">
                        <label for="flujo">Flujo
                        </label>
                        <validacion/>
                        <v-select id="flujo" name="flujo" placeholder="Seleccione el flujo"
                                  label="flujoExpedienteDigial"
                                  :options="listaFlujoExpedinteDigital"
                                  v-model="configuracion.flujo"
                        ></v-select>
                      </b-form-group>
                    </b-col>
                    <b-col>
                      <b-form-group
                          align="left"
                      >
                        <label for="clinica">Tipo de archivo</label>
                        <validacion/>
                        <v-select
                            name="extensiones"
                            placeholder="Tipo de archivo"
                            label="extension"
                            multiple
                            :reduce="(variable) => variable"
                            :options="listaExtensiones"
                            v-model="configuracion.extensiones"
                        ></v-select>
                      </b-form-group>
                    </b-col>
                      <b-col>
                        <b-form-group
                            align="left"
                        >
                          <label for="idEstudioDiagnocat">Tipo de estudios Diagnocat</label>
                          <v-select id="idEstudioDiagnocat" name="idEstudioDiagnocat" placeholder="Seleccione el estudio de diagnocat"
                                    label="estudioDiagnocat"
                                    :options="tipoEstudiosDiagnocat"
                                    v-model="configuracion.estudioDiagnocat"
                          ></v-select>
                        </b-form-group>
                      </b-col>
                    <b-col>
                      <b-form-group
                            v-slot="{ ariaDescribedby }"
                        ><label for="clinica">¿Para qué tipo de clínica aplica?</label>
                          <validacion/>
                        <b-form-checkbox
                            name="extensiones"
                            placeholder="Seleccione Categoría"
                            label="descripcion"
                            multiple
                            :reduce="(variable) => variable"
                            :options="categoriaClinicaArray"
                            v-model="configuracion.categorias"
                            switch
                            inline
                            v-for="(option, index) in categoriaClinicaArray"
                            :key="index"
                            :value="option.idCategoria"
                            @change="obtenerClinicasPorCartegorias"
                        >
                            {{ option.descripcion }}
                          </b-form-checkbox>
                      </b-form-group>
                    </b-col>
                    <b-button ref="submitGuardar" type="submit" style="visibility: hidden"></b-button>
                    </b-row>

                  </b-form>
              </b-col>
              <b-col>
                <p style="color: var(--color-icono); font-weight: 600">Clínicas excluidas</p>
                <div class="contenedorTablaSinColor p-4" :class="configuracion.categorias.length === 0 ? 'd-flex justify-content-center align-items-center':''" style="height: 50vh;">
                  <p v-if="configuracion.categorias.length === 0">
                    Primero selecciona un tipo de clínica
                  </p>
                  <div v-else class="ml-3">
                    <b-row>
                      <b-col class="contenedorTablaSinColor d-flex text-left" cols="11">
                        <font-awesome-icon style="color: #17a3b888;" class="mt-auto mb-auto ml-2" icon="filter">
                        </font-awesome-icon>
                        <b-input-group>
                          <b-form-input
                              class="input-filter"
                              type="text"
                              id="filterInput"
                              placeholder="Búsqueda de clínica"
                              v-model="valorFiltroClinicaExcluidos"
                              @keyup.prevent="buscarClinicasExcluidasEnFiltros"
                          >

                          </b-form-input>
                        </b-input-group>
                      </b-col>
                      <b-col cols="1">
                        <b-button
                          id="popoverAgregaClinica"
                          class="redondeo "
                          size="sm"
                          variant="info"
                        >
                          <em class="mas_svg icon-boton sm"></em>
                        </b-button>
                        
                        <b-popover target="popoverAgregaClinica" placement="bottomright">
                          <div class="m-2">
                            <p style="color: var(--color-icono); font-weight: 600">Agregar clínica a excluidos</p>
                            <div class="contenedorTablaSinColor d-flex text-left">
                              <font-awesome-icon style="color: #17a3b888;" class="mt-auto mb-auto ml-2" icon="filter">
                              </font-awesome-icon>
                              <b-input-group>
                                <b-form-input
                                    v-model="valorFiltroClinica"
                                    class="input-filter"
                                    type="text"
                                    id="filterInput"
                                    placeholder="Búsqueda de clínica"
                                    @keyup.prevent="buscarClinicasEnFiltros"
                                >
                                </b-form-input>
                              </b-input-group>
                            </div>

                            <b-form-checkbox-group class="mt-3" v-model="clinicasExcluidasDos"  stacked style="overflow: auto; max-height: 200px">
                              <template v-for="(op, index) in datosTabla1">
                                <b-form-checkbox  :key="op.idClinica"
                                                  :value="op"
                                                  @change="initConfiguracionesClinicaEdit(1, op, index)" v-if="op.visible">
                                {{op.strNombre}}
                                </b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </div>
                        </b-popover>
                      </b-col>
                      <b-col cols="12">
                          <div style="overflow: auto;   max-height: 70% " class="scrollPorTabs">
                            <b-form-checkbox-group class="mt-3" v-model="clinicasExcluidasDos" stacked>
                              <template v-for="(op, index) in configuracion.clinicas">
                                <b-form-checkbox  :key="op.idClinica"
                                                  :value="op"
                                                  @change="initConfiguracionesClinicaEdit(2,op, index)" v-if="op.visible">
                                  {{op.strNombre}}
                                </b-form-checkbox>
                              </template>
                            </b-form-checkbox-group>
                          </div>


                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-col>
            </b-row>


          <template #modal-footer="{ ok, cancel }">
            <div class="w-100 float-none text-center">
              <b-button  class="mt-3 botonesAzulFuerte"
                         style="width:10%;margin:10px"
                         variant="primary"
                         :disabled="loaderAcciones"
                         @click="guardar()">Crear</b-button>
              <b-button
                  style="width:10%;margin:10px"
                  class="mt-3 botonesGrisFuerte"
                  :disabled="loaderAcciones"
                  @click="cerrarModal()">Cancelar</b-button>
            </div>
          </template>
        </b-modal>
    </b-card>
  </div>
</template>

<script>
import Header from "../../components/Header";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import buscarCp from "@/components/codigoPostal/BuscarCp.vue";

export default {
  name: "cargaHdxEce",
  components: {
    Header
  },
  mixins: [validationMixin],
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      opcionesCategoriaClinica: [],
      categoriaClinicaArray: [],
      datosTabla: [],
      datosTabla1: [],
      fields: [
        {key: "idHerramienta", label: "ID Herramienta", sortable: true},
        {key: "flujo", label: "Flujo", sortable: true},
        {key: "nombreHerramienta", label: "Nombre de Herramienta", sortable: true},
        "Acciones",
      ],
      registrosPorPagina: 10,
      paginaActual: 1,
      filtro: {
        id: null,
        palabraClave: null,
        registroActivo: null
      },
      tituloModal: '',
      loaderAcciones: false,
      show: false,
      configuracion: {
        idHerramienta: null,
        nombreHerramienta: null,
        flujo: null,
        extensiones: [],
        categorias: [],
        registroActivo: null,
        clinicas: []
      },
      loader: false,
      options: [],
      listaExtensiones: [],
      listaFlujoExpedinteDigital: [],
      clinicasExcluidasUno: [],
      clinicasExcluidasDos: [],
      valorFiltroClinica: null,
      valorFiltroClinicaExcluidos: null,
      tipoEstudiosDiagnocat: [],
    }
  },
  validations: {
    configuracion: {
      nombreHerramienta: {required},
      flujo: {required},
      extensiones: {required},
      categorias: {required},
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
    //this.obtenerConfiguracionHerramientasECE();
    this.lstCategoriaClinicas();

    this.obtenerExtensiones();
    this.obtenerFlujosExpediente();
    this.obtenerConfigHerramientasECE();
    this.obtenerEstudiosOriginalesDiagnocat();
  },
  methods: {
    buscarCp() {
      return buscarCp
    },
    obtenerConfiguracionHerramientasECE() {
      this.loader = true;
      this.$http
          .post(this.$api + "rutaExpediente/obtenerConfiguracionHdx", this.filtro)
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.datosTabla = respuesta.data.data;

              this.datosTabla.forEach(itm => {
                if (itm.categoria.length > 0) {
                  let temp = [];
                  itm.categoria.forEach(item => {
                    temp.push(item.idCategoria)
                  });
                  itm.categoria = temp;
                }
              })
            }
          })
          .finally(() => {
            this.loader = false;
          });
    },
    activarDesactivarConfiguracion(item) {
      // item.loader = true;
      const mensaje = item.registroActivo ? '¿Está seguro de desactivar la herramienta?' : '¿Está seguro de activar la herramienta?';
      this.$swal({
        icon: "warning",
        text: mensaje,
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          this.loader = true;
          const parametros = {
            idHerramienta: item.idHerramienta,
          }
          this.$http.post(this.$api + 'herramientaExpedienteElectronico/activarDesactivarHerramienta',  parametros).then(respuesta => {
                if (respuesta.data.data) {
                  this.loader = false;
                  item.registroActivo = !item.registroActivo;
                  this.$swal.fire({
                    icon: "info",
                    title: "Aviso",
                    text: "La herramienta se actualizó correctamente",
                  });
                }
              }
          )
        } else {
          item.loader = false;
        }
      })
    },
    agregar() {
      this.configuracion = {
        cantidadArchivos: 1,
        flujo: null,
        idConfiguracionHdx: null,
        nombreHerramienta: null,
        registroActivo: null,
        tipoArchivo: null,
        categorias: [],
        clinicas:[],
        rutaECE: {
          idRuta: 6
        }
      }
      this.tituloModal = 'Crear herramienta';
      this.show = true;
      this.valorFiltroClinicaExcluidos = null;
      this.valorFiltroClinica = null;
    },
    cerrarModal() {
      this.show = false;
    },
    validateState(name) {
      const {$dirty, $error} = this.$v.configuracion[name];
      return $dirty ? !$error : null;
    },
    guardar() {
        this.$v.configuracion.$touch();
        if (this.$v.configuracion.$anyError) {
          return;
        }
        this.loaderAcciones = true;
        this.$http.post(this.$api + 'herramientaExpedienteElectronico/guardarHerramientasECE', this.configuracion).then(respuesta => {
              if (respuesta.data.data) {
                this.filtro = {
                  id: null,
                  palabraClave: null,
                  registroActivo: null
                };
                this.obtenerConfigHerramientasECE();
                this.show = false;
                this.$swal.fire({
                  icon: "info",
                  title: "Aviso",
                  text: "La configuracion se guardó correctamente",
                });
              }
            }
        ).catch(error => {
          console.error( error.message)
          this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: error.message,
          });
        }).finally(() => {
              this.loaderAcciones = false;
            }
        )
    },
    modificar(item) {
      this.configuracion = JSON.parse(JSON.stringify(item));

      this.configuracion.clinicas = this.configuracion.clinicas.map(obj => {
         return { ...obj, visible: false };
      })

      this.tituloModal = 'Modificar herramienta';
      this.show = true;
      this.clinicasExcluidasDos = this.configuracion.clinicas;
      this.valorFiltroClinica = null;
      this.valorFiltroClinicaExcluidos = null;
      this.obtenerClinicasPorCartegorias();
      this.buscarClinicasExcluidasEnFiltros();
    },
    lstCategoriaClinicas() {
      this.opcionesCategoriaClinica = [];
      this.options = [];
      this.$http.get(this.$api + "catalogos/obtenerCategoriasClinicasAAA").then(response => {
        if (response.data.data) {
          var arrayC = response.data.data.map((c) => {
            return {
              idCategoria: c.idCategoria,
              descripcion: c.descripcion
            }
          });
          this.categoriaClinicaArray = arrayC.filter(function (item) {
            return item.idCategoria != 0;
          })
          this.categoriaClinicaArray.forEach(it => it.idCategoria);
        }
      })
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Za-zÁÉÍÓÚáéíóúñÑ/^\s+$/]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    obtenerExtensiones() {
      this.$http.get(this.$api + 'catalogos/obtenerExtensiones').then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.listaExtensiones.push(it);
              })
            }
          }
      )
    },
    obtenerFlujosExpediente() {
      this.$http.get(this.$api + 'catalogos/obtenerFlujoExpedinteDigital').then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.listaFlujoExpedinteDigital.push(it);
              })
            }
          }
      )
    },
    obtenerConfigHerramientasECE() {
      this.loader = true;
      this.$http
          .post(this.$api + "herramientaExpedienteElectronico/obtenerHerramientasECE", this.filtro)
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.datosTabla = respuesta.data.data;

              this.datosTabla.forEach( itm => {
                if (itm.categorias.length > 0){
                  let temp = [];
                  itm.categorias.forEach( item => {
                    temp.push(item.idCategoria)
                  });
                  itm.categorias = temp;
                }
              })
            }
          })
          .finally(() => {
            this.loader = false;
          });
    },
    obtenerClinicasPorCartegorias() {
      this.$http
          .post(this.$api + "catalogos/listaClinicasCategorias", {idEstatus:this.configuracion.categorias})
          .then((respuesta) => {
            if (respuesta.data.data) {
              this.datosTabla1 = respuesta.data.data;

              this.datosTabla1.map((it,index) => {
                if(this.configuracion.clinicas.some((idp) => idp.idClinica === it.idClinica)){
                  this.datosTabla1.splice(index,1);
                }
              })

              this.datosTabla1 = this.datosTabla1.map(obj => {
                return { ...obj, visible: false };
              })

              this.buscarClinicasEnFiltros();
            }
          })
          .finally(() => {
          });
    },
    submitGuardar() {
      this.$refs.submitGuardar.click();
    },
    initConfiguracionesClinicaEdit(tipo, op, index){
      if(tipo === 1){
        this.configuracion.clinicas.push(op);
        this.datosTabla1.splice(index, 1)
      }else{
        this.datosTabla1.push(op);
        this.configuracion.clinicas.splice(index,1);
      }
    },
    buscarClinicasEnFiltros() {
      this.datosTabla1.forEach(it=>{

        if (this.valorFiltroClinica !== undefined && this.valorFiltroClinica !== null
        && this.valorFiltroClinica !== '') {
          it.visible = false;

          if (it.strNombre.toUpperCase().includes(this.valorFiltroClinica.toUpperCase())) {
            it.visible = true;
          }
        } else {
          it.visible = true;
        }
      });
    },
    buscarClinicasExcluidasEnFiltros() {

      this.configuracion.clinicas.forEach(it=>{

        if (this.valorFiltroClinicaExcluidos !== undefined && this.valorFiltroClinicaExcluidos !== null
        && this.valorFiltroClinicaExcluidos !== '') {
          it.visible = false;

          if (it.strNombre.toUpperCase().includes(this.valorFiltroClinicaExcluidos.toUpperCase())) {
            it.visible = true;
          }
        } else {
          it.visible = true;
        }
      });
    },
    obtenerEstudiosOriginalesDiagnocat() {
      this.$http.get(this.$api + 'diagnocat/obtenerEstudiosOriginalesDiagnocat').then(respuesta => {
            if (respuesta.data.data) {
              respuesta.data.data.forEach(it => {
                this.tipoEstudiosDiagnocat.push(it);
              })
            }
          }
      )
    },
  }
};
</script>

<style scoped>
.input-filter,
.input-filter:focus {
  background: transparent;
  border: 0px;
  box-shadow: 0 0 0 0 rgb(0 123 255 / 25%);
}
.icon-boton {
  filter: brightness(0) invert(1);
  height: 20px;
  display: block;
}
.paddingbotones {
  padding: 3px;
}

.marginbotones{
  border-radius:20px;
}

.redondeo{
  border-radius: 50px !important;
}
.botonesGrisFuerte {
  border-radius: 10rem;
  color: #fff;
  margin-left: 5%;
}
.botonesAzulFuerte {
  border-radius: 10rem;
  color: #fff;
  background-color: var(--color-icono);
  border-color: var(--color-icono);
  margin-left: 5%;
}
.bCardConfiguracion {
  margin: 2%;
  padding: 0;
  border-radius: 20px;
}

.bCardConfiguracion .card-body {
  padding: 0.5rem;
}

.scrollPorTabs {
  height:47vh;
  overflow-y: scroll;
  overflow-x: hidden
}
</style>
